import type { CSSProperties } from "react";
import { sizedDeckImage } from "@lunary/app-core/deck-model";
import { useCardFace } from "./deck";
import { cardName } from "@lunary/app-core/reading-chat-model";
import { toRoman } from "@lunary/app-core/roman";
import styles from "./reading-chat.module.css";

const WIDTH = 60;
const OVERLAP = 26;

function StaticCard({ number }: { number: number }) {
  const src = useCardFace(number);
  const name = cardName(number);
  return (
    <div className={styles.heroCard} style={{ width: WIDTH }}>
      {src ? (
        <img src={sizedDeckImage(src, WIDTH)} alt={name} decoding="async" draggable={false} />
      ) : (
        <span className={styles.heroCardFallback}>{toRoman(number)}</span>
      )}
    </div>
  );
}

export function ReadingHeroCards({ cards }: { cards: readonly number[] }) {
  if (cards.length === 0) return null;
  const fanWidth = WIDTH + (cards.length - 1) * (WIDTH - OVERLAP);
  return (
    <div className={styles.heroCards} style={{ "--n": cards.length } as CSSProperties}>
      <div className={styles.heroFan} style={{ width: fanWidth }}>
        {cards.map((c) => (
          <div key={c} className={styles.heroFanItem}>
            <StaticCard number={c} />
          </div>
        ))}
      </div>
      <span className={styles.heroCardName}>{cards.map(cardName).join(" · ")}</span>
    </div>
  );
}
